import React, { ReactNode } from 'react';
import Box from 'carbon-react/lib/components/box';
import Message from 'carbon-react/lib/components/message';

import { FormattedMessage } from '@futrli/localisation';

interface TabErrorMessageProps {
  message?: ReactNode;
}

export const TabErrorMessage = ({ message }: TabErrorMessageProps) => (
  <Box p={4} display="flex" justifyContent="center">
    <Message variant="error" open showCloseIcon={false}>
      {message ?? (
        <FormattedMessage
          id="predict.error_loading_data"
          defaultMessage="An error occurred while loading the data from the server."
        />
      )}
    </Message>
  </Box>
);
